<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save detail-mode"
    >
      <div class="wrap-screen-mode justify-content-between">
        <!-- Screen Mode -->
        <div class="screen-mode">
          <!-- Page Screen -->
          <div
            :class="{'selected': dataSetup.is_pagescreen}"
            class="screen-list"
            @click="dataSetup.is_pagescreen = true"
          >
            <img src="@/assets/new-form-ui/screen-mode/page-screen.svg">
          </div>
          <!-- Modal Screen -->
          <div
            :class="{'selected': !dataSetup.is_pagescreen}"
            class="screen-list"
            @click="dataSetup.is_pagescreen = false"
          >
            <img src="@/assets/new-form-ui/screen-mode/modal-screen.svg">
          </div>
          <!-- Text -->
          <div class="screen-text">
            <p>VIEW MODE</p>
            <p>{{ `${dataSetup.is_pagescreen ? 'Page' : 'Modal'} Screen` }}</p>
          </div>
        </div>

        <button
          class="save-button"
          @click="submitForm"
        >
          Save
        </button>
      </div>
    </div>

    <!-- Card Page -->
    <div
      id="cardPage"
      class="card-page card-page-detail"
    >
      <!-- Button Code Editor per View -->
      <div class="icon-code-editor icon-code-editor--only">
        <img
          src="@/assets/new-form-ui/code-editor.svg"
          @click="openModalCodeEditor"
        >
        <div class="tooltip-component">
          Code Editor
        </div>
      </div>
      <div
        :class="{'card-page-title--white' : !dataSetup.is_pagescreen}"
        class="card-page-title">
        <input
          v-model="dataSetup.title"
          :class="{'error-input' : $v.dataSetup.title.$error}"
          type="text"
          class="input-title"
          placeholder="Enter title here"
        >
      </div>
      <div class="card-page-content">
        <!-- Config Field & Action Button -->
        <b-row class="mb-5">
          <b-col :cols="dataSetup.is_pagescreen ? 8 : 12">
            <section
              :class="{'have-data': dataSetup.column && dataSetup.column.length > 0}"
              class="section-field"
            >
              <h5>Fields</h5>
              <!-- If loading -->
              <j-skeleton-field v-if="isLoading" />

              <!-- If not loading -->
              <draggable
                v-if="!isLoading"
                v-model="dataSetup.column"
                :options="{
                  animation:300,
                  disabled: selectedIndexField,
                  handle:'.icon-drag'
                }"
                group="fieldsLibrary"
                class="wrap-field no-gutters"
                @change="modifyData"
              >
                <div
                  v-for="(column, index) in dataSetup.column"
                  :key="column.field_ui_key"
                  :class="`col-md-${column.grid_size ? column.grid_size : 12}`"
                  style="padding-right: 10px;"
                >
                  <div
                    :class="{'selected': index === selectedIndexField}"
                    class="field-list"
                    @click="openPropertiesField(column, index)"
                  >
                    <p class="column-name">{{ column.name }}</p>

                    <field-preview
                      :column="column"
                    />

                    <!-- Edit or Delete -->
                    <div class="edit-or-delete">
                      <div class="button">
                        <!-- Edit -->
                        <div
                          class="edit"
                          @click.stop="openPropertiesField(column, index)"
                        >
                          <i class="fa fa-pencil-square-o" />
                          <div class="tooltip-component">Edit field</div>
                        </div>
                        <!-- Delete -->
                        <div
                          class="delete"
                          @click.stop="deleteField(index)"
                        >
                          <i class="fa fa-trash" />
                          <div class="tooltip-component">Delete field</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>

              <!-- Add new field -->
              <div
                class="btn-add-more mt-3"
                @click="openModalFieldLibrary(false)"
              >
                <img
                  :src="require('@/assets/icon/add.png')"
                  class="m__r--5"
                  height="15"
                  width="15">
                Add Fields
              </div>
            </section>
          </b-col>

          <!-- Action Button -->
          <b-col
            v-if="dataSetup.is_pagescreen"
            cols="4"
          >
            <section>
              <h5>Action Button</h5>

              <!-- If loading -->
              <j-skeleton-action-button v-if="isLoading" />

              <!-- If not loading -->
              <draggable
                v-if="!isLoading"
                v-model="dataSetup.action_buttons"
              >
                <div
                  v-for="(button, index) in dataSetup.action_buttons"
                  :key="index"
                  :class="{'selected': index === selectedIndexBtn}"
                  class="action-button-list"
                  @click="openConfigActionButton(button, index)"
                >
                  <i
                    :class="`icon-button fa ${button.icon_web.includes('fa-') ? button.icon_web : 'fa-' + button.icon_web}`"
                  />
                  {{ button.label }}

                  <!-- Edit or Delete -->
                  <div class="edit-or-delete">
                    <div class="button">
                      <!-- Edit -->
                      <div
                        class="edit"
                        @click.stop="openConfigActionButton(button, index)"
                      >
                        <i class="fa fa-pencil-square-o" />
                      </div>
                      <!-- Delete -->
                      <div
                        class="delete"
                        @click.stop="deleteActionButton(index)"
                      >
                        <i class="fa fa-trash" />
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>

              <!-- Add new action button -->
              <div
                class="btn-add-more"
                @click="openConfigActionButton(null, null)"
              >
                <img
                  :src="require('@/assets/icon/add.png')"
                  class="m__r--5"
                  height="15"
                  width="15">
                Add Button
              </div>
            </section>
            <section
              v-if="isWorkflow"
              class="m__t--15">
              <h5>Record Activity</h5>

              <div class="configuration-log-workflow">
                <div class="configuration-toggle-in-title">
                  <div class="wrap-title">
                    <h4 class="configuration-section-title">Hidden Log Workflow </h4>
                    <p class="configuration-section-desc">
                      If the <b>Hidden Log Workflow</b> toggle is enabled, the <b>Log Workflow</b> in the record details will disappear.
                    </p>
                  </div>
                  <j-switch v-model="dataSetup.is_hidden_log_workflow" />
                </div>
              </div>
            </section>
          </b-col>
        </b-row>

        <!-- Config Button -->
        <b-row>
          <b-col :cols="dataSetup.is_pagescreen ? 8 : 12">
            <section>
              <h5>Button</h5>

              <native-buttons
                :data-buttons="nativeButtons"
                :is-workflow="isWorkflow"
                :is-dynamic-workflow="isDynamicWorkflow"
                :is-approver-selection-by-function="isApproverSelectionByFunction"
                :is-page-screen="dataSetup.is_pagescreen"
                :button-active="modeBtn"
                menu="detail"
                @select-btn="openConfigNativeButton"
              />
            </section>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Delete View -->
    <div class="card-transparent card-transparent-detail m__t--15">
      <span
        v-if="formDetail.detail_view"
        class="cursor-pointer"
        style="font-size: 14px"
        @click="deleteView('detail')"
      >
        <i class="fa fa-trash"/> <small>Delete this view</small>
      </span>
    </div>

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idPropertiesField"
      :id="[idPropertiesField]"
      :field-detail="selectedField"
      :variable-options="variableOptions"
      :field-ui-key="dataSetup.column"
      :is-page-screen="dataSetup.is_pagescreen"
      :is-detail-view="true"
      :is-new-field="isNewField"
      :variable-options-watermark="variableOptionsWatermark"
      :native-buttons="nativeButtons"
      @delete-field="deleteField"
      @close-properties="toggleProperties(false)"
      @submit-preview="submitPreview"
      @submit-mode="submitField"
      @open-modal-full-script="openModalFullScript"
      @open-modal-company-drive="openModalCompanyDrive"
    />

    <!-- Configuration Action Button -->
    <action-button-configuration
      v-if="isOpenConfigActionBtn"
      :id="idConfigActionBtn"
      :field-detail="selectedBtn"
      :variable-options="variableOptions"
      @close-configuration="toggleConfigurationActionBtn(false)"
      @delete-action-button="deleteActionButton"
      @submit-configuration="submitActionButton"
    />

    <!-- Configuration Native Button -->
    <native-button-configuration
      v-if="isOpenConfigNativeBtn"
      :id="idConfigNativeBtn"
      :field-detail="selectedNativeBtn"
      :is-revision-btn="isRevisionBtn"
      :label="labelBtn"
      :mode="modeBtn"
      @close-configuration="toggleConfigurationNativeBtn(false)"
      @submit-configuration="submitNativeButton"
    />

    <!-- Modal External Api -->
    <b-modal
      ref="modalExternalApi"
      :hide-header="true"
      :hide-footer="true"
      class="modal-external-api"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-external-api-field
        v-if="showModalExternalUrl"
      />
    </b-modal>

    <!-- Modal Icon Action Button -->
    <modal-icon-action-btn
      v-if="showModalIconActionBtn"
      :id="idConfigIconActionBtn"
      @select-icon="selectIconActionBtn"
      @close-modal="closeModalIconActionBtn"
    />

    <!-- Modal Script Action Button -->
    <b-modal
      ref="modalScriptActionBtn"
      :hide-header="true"
      :hide-footer="true"
      class="modal-native-action-button"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-script-action-btn
        v-if="showModalScriptActionBtn"
      />
    </b-modal>

    <!-- Modal Script Before & After -->
    <b-modal
      ref="modalScriptBeforeAfter"
      :hide-header="true"
      :hide-footer="true"
      class="modal-native-action-button"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-script-before-after-field
        v-if="showModalScriptBeforeAfter"
      />
    </b-modal>

    <!-- Modal Full Screen Script On Change -->
    <b-modal
      ref="modalFullScript"
      class="mod-full-block"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-fullscreen">
        <div class="d-flex align-items-center justify-content-between">
          <div class="label-log-detail">Script</div>
          <img
            src="@/assets/icon/minimize.svg"
            alt="fullscreen"
            class="pull-right cursor-pointer"
            @click="minimizeBlock"
          >
        </div>

        <j-monaco-editor
          v-if="openEditor"
          ref="scriptEditor"
          :value="onValueChange"
        />

        <div
          class="btn-update-properties-automation"
          @click="minimizeBlock">Update</div>
      </div>
    </b-modal>

    <!-- Modal Code Editor -->
    <b-modal
      ref="modalCodeEditor"
      :hide-header="true"
      :hide-footer="true"
      class="modal-code-editor-wrap"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-code-editor
        v-if="showModalCodeEditor"
        :view-data="viewJsonData"
        view-title="Detail View"
        type="detail_view"
        @close="closeModalCodeEditor"
        @update="updateViewByCode"
      />
    </b-modal>

    <modal-company-drive
      v-if="showModalCompanyDrive"
      @close-popup="handleCloseModalCompanyDrive"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-param-reassign */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
// Mixins
import jMixSetupCreateDetail from '@/mixins/form-ui-v2/jMixSetupCreateDetail';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixSetupNativeButton from '@/mixins/form-ui-v2/jMixSetupNativeButton';
import jMixSetupActionButton from '@/mixins/form-ui-v2/jMixSetupActionButton';
import jMixCodeEditorPerView from '@/mixins/form-ui-v2/jMixCodeEditorPerView';
// Components
import draggable from 'vuedraggable';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import ModalExternalApiField from '@/views/experience-manager-v2/popup/ModalExternalApiField';
import ModalScriptBeforeAfterField from '@/views/experience-manager-v2/popup/ModalScriptBeforeAfterField';
import NativeButtons from '@/views/experience-manager-v2/partials/NativeButtons';
import NativeButtonConfiguration from '@/views/experience-manager-v2/partials/configuration/NativeButtonConfiguration';
import ActionButtonConfiguration from '@/views/experience-manager-v2/partials/configuration/ActionButtonConfiguration';
import ModalIconActionBtn from '@/views/experience-manager-v2/popup/ModalIconActionBtn';
import ModalScriptActionBtn from '@/views/experience-manager-v2/popup/ModalScriptActionBtn';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import ModalCodeEditor from '@/views/experience-manager-v2/popup/ModalCodeEditor';
import ModalCompanyDrive from '@/views/visual-programming/popup/ModalCompanyDrive';
import jSwitch from '@/components/inputs/jSwitch';
// Skeleton
import jSkeletonField from '@/views/experience-manager-v2/loading/jSkeletonField';
import jSkeletonActionButton from '@/views/experience-manager-v2/loading/jSkeletonActionButton';

export default {
  components: {
    draggable,
    FieldPreview,
    ModalFieldLibrary,
    PropertiesField,
    ModalExternalApiField,
    ModalScriptBeforeAfterField,
    NativeButtons,
    NativeButtonConfiguration,
    ActionButtonConfiguration,
    ModalIconActionBtn,
    ModalScriptActionBtn,
    jSkeletonField,
    jSkeletonActionButton,
    jMonacoEditor,
    ModalCodeEditor,
    ModalCompanyDrive,
    jSwitch,
  },

  mixins: [jMixSetupCreateDetail, jMixToolbox, jMixScroll, jMixSetupActionButton, jMixSetupNativeButton, jMixCodeEditorPerView],

  validations: {
    dataSetup: {
      title: { required },
      column: {},
      action_buttons: {},
    },
  },

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      isOpen: false,
      dataSetup: {
        title: null,
        column: [],
        is_pagescreen: true,
        action_buttons: [],
        is_hidden_log_workflow: false,
      },
      variableOptions: [],
      problemMessage: '',
      isError: false,
      modeBtn: '',
      darkMode: false,
      typeOptions: [
        {
          id: 'confirmation',
          name: 'Confirmation',
        },
        {
          id: 'message',
          name: 'Message',
        },
      ],
      openEditor: false,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),

    genData() {
      const { title, column, is_pagescreen, action_buttons, is_hidden_log_workflow } = this.dataSetup;

      const params = this._.cloneDeep(this.formDetail);
      params.detail_view = {
        title,
        columns: column,
        is_pagescreen,
        action_buttons: action_buttons.length > 0 ? action_buttons : null,
        is_hidden_log_workflow,
      };
      params.native_buttons = {
        approve: this.nativeButtons.approve,
        create: this.nativeButtons.create,
        delete: this.nativeButtons.delete,
        reject: this.nativeButtons.reject,
        update: this.nativeButtons.update,
        draft: this.nativeButtons.draft,
        submit: this.nativeButtons.submit,
        close: this.nativeButtons.close,
        cancel: this.nativeButtons.cancel,
        need_revision: this.nativeButtons.revision,
        approve_update: this.nativeButtons.approveUpdate,
      };
      return params;
    },

    isWorkflow() {
      return this.formData ? this.formData.is_use_workflow : false;
    },

    isDynamicWorkflow() {
      return this.formData ?
        (!!(this.formData.workflow && this.formData.workflow.type === 'dynamic')) : false;
    },
    isApproverSelectionByFunction() {
      return this.formData ?
        (!!(this.formData.workflow && this.formData.workflow.approver_selection === 'function')) : false;
    },

    viewJsonData() {
      return JSON.stringify(this.formDetail.detail_view, null, 4);
    },
  },

  watch: {
    form_data_detail(val) {
      if (val.length > 0) {
        this.setDetail(val[0].columns);
      }
    },

    // eslint-disable-next-line
    'dataSetupBtn.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetupBtn.key =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.actionGetDetailFormData(param);
      this.isLoading = false;
    } else if (this.formDetail.data_source.dataset && this.formDetail.data_source.dataset.dataset_id) {
      const req = {
        id: this.formDetail.data_source.dataset.dataset_id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        const detailDataset = res.data || null;
        this.isLoading = false;
        this.setIsDataSet(true);

        if (detailDataset) {
          this.setDetail(detailDataset.column);
        }
      });
    } else {
      await this.setExternalUrl();
      this.isLoading = false;
    }
  },

  methods: {
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    setDetail(columns) {
      const listColumns = Object.keys(columns);
      const valueListColumns = Object.values(columns);
      this.variableOptions = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          this.variableOptions.push({
            id: column,
            label: column,
            text: column,
            type: valueListColumns[index].type,
          });
        });
      }

      if (this.formDetail.detail_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.detail_view));
        const { title, is_pagescreen, action_buttons, is_hidden_log_workflow } = data;
        this.dataSetup.title = title;
        this.dataSetup.is_pagescreen = is_pagescreen;
        this.dataSetup.action_buttons = action_buttons || [];
        this.dataSetup.is_hidden_log_workflow = is_hidden_log_workflow;

        if (this.formDetail.detail_view.columns && this.formDetail.detail_view.columns.length > 0) {
          this.dataSetup.column = [];
          this.formDetail.detail_view.columns.forEach((column) => {
            this.dataSetup.column.push(column);
          });
        }
      }
    },

    setExternalUrl() {
      const listColumns = Object.keys(this.formDetail.data_source.external_url.columns);
      const valueListColumns = Object.values(this.formDetail.data_source.external_url.columns);
      this.variableOptions = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          this.variableOptions.push({
            id: column,
            label: column,
            text: column,
            type: valueListColumns[index].type,
          });
        });
      }

      if (this.formDetail.detail_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.detail_view));
        const { title, is_pagescreen, action_buttons, is_hidden_log_workflow } = data;
        this.dataSetup.title = title;
        this.dataSetup.is_pagescreen = is_pagescreen;
        this.dataSetup.action_buttons = action_buttons || [];
        this.dataSetup.is_hidden_log_workflow = is_hidden_log_workflow;

        if (this.formDetail.detail_view.columns && this.formDetail.detail_view.columns.length > 0) {
          this.formDetail.detail_view.columns.forEach((column) => {
            this.dataSetup.column.push(column);
          });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jDetailView.vue